exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selWidth[data-v-01323e9e]{\n  width: 90%;\n}\n.margin_top_20[data-v-01323e9e]{\n  margin-top:20px;\n}\n.flex-end[data-v-01323e9e]{\n   display: -webkit-box;\n   display: -ms-flexbox;\n   display: flex;\n   -webkit-box-pack: end;\n       -ms-flex-pack: end;\n           justify-content: flex-end;\n   -webkit-box-align: center;\n       -ms-flex-align: center;\n           align-items: center;\n}\n", ""]);

// exports
